import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlayground: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPlayground"><Path d="M14.4453 13C12.2362 13 10.4453 14.7909 10.4453 17C10.4453 19.2091 12.2362 21 14.4453 21C16.6545 21 18.4453 19.2091 18.4453 17C18.4453 14.7909 16.6545 13 14.4453 13Z" fill="currentColor"/><Path d="M13.9885 2.52527L11.918 10.2527L19.6454 12.3232L21.7159 4.59582L13.9885 2.52527Z" fill="currentColor"/><Path d="M4.01945 5.25256L2.21484 15.487L11.9804 11.9326L4.01945 5.25256Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlayground;
